import { Button } from '@material-ui/core'
import i18n from '../../../translations/i18n'

import { MuiClasses } from '../../../types'

interface BackButtonProps {
  classes?: MuiClasses
  doStepBack: () => void
  currentStep: number
  disabled?: boolean // Added disabled prop
}

export const BackButton = ({
  classes,
  doStepBack,
  currentStep,
  disabled = false
}: BackButtonProps) => {
  return (
    <Button
      disabled={currentStep === 0 || disabled}
      onClick={doStepBack}
      style={{ width: '100%', height: '42px' }}
    >
      {i18n.t('general.back')}
    </Button>
  )
}
